export const DEFAULT_MESSAGES = {
    PRE_TITLE: 'We\'re changing our name to Vrbo',
    POST_TITLE: 'HomeAway has a new name. Welcome to Vrbo!.',
    PRE_INFO: 'New name. Same great vacation rentals. Coming soon!',
    POST_INFO: 'New name. Same great vacation rentals. Log in with your HomeAway password.',
    LEARN_MORE: 'Learn more'
};

export const LINGUA_KEYS = {
    PARTNER_DASH: '.px.dashboard',
    OWNER_LOGIN: '.px.login',
    LYP: '.px.lyp',
    TX: ''
};
